export default __webpack_public_path__ + "static/media/calendar_expired.c770a665.png";